import { useEffect } from 'react';
import { scheduleStopDriverSharing, startDriverSharing } from '../lib/driverGps';

// Mounted once by Layout for users who can drive. Renders nothing: it only
// keeps the module-level GPS publisher (lib/driverGps.js) alive for as long as
// this user is logged in, so a driver keeps sharing their position while they
// move between screens. The publisher itself decides whether there is anything
// to share (an assigned order out for delivery) and goes quiet otherwise.
export default function DriverLocationSharer({ userId, enabled }) {
  useEffect(() => {
    if (!enabled || !userId) return undefined;
    startDriverSharing(userId);
    return () => scheduleStopDriverSharing();
  }, [userId, enabled]);
  return null;
}
